import React from "react"
import {
  type IconProps,
  iconColorCss,
  iconSizeCss,
} from "@myvp/shared/src/styles/icon-utils"

const Info = (props: { variant?: "filled" | "default" } & IconProps) => (
  <svg
    className={props.className}
    viewBox={props.variant === "filled" ? "0 0 24 24" : "0 0 16 16"}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    css={[iconSizeCss(props.size), iconColorCss(props.color)]}
  >
    {props.variant === "filled" ? (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM11 7V9H13V7H11ZM11 11V17H13V11H11Z"
        fill="var(--color)"
      />
    ) : (
      <>
        <circle
          cx="8"
          cy="8"
          r="6.25"
          stroke="var(--color)"
          strokeWidth="1.5"
        />
        <path d="M8 11V8M8 6.5V5" stroke="var(--color)" strokeWidth="1.5" />
      </>
    )}
  </svg>
)

export default Info
